import(/* webpackMode: "eager" */ "/app/src/app/(landing-page)/(static-pages)/layout.tsx")